package com.yogaaicoach.pages.trainingprogram

import com.yogaaicoach.scope
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.useEffectOnce
import react.useState
import web.cssom.ClassName

internal external interface UpdateLevelPageProps : Props {
    var viewModel: UpdateTrainingViewModel
    var onDone: () -> Unit
}

private data class UpdateLevelContent(val key: LevelKey, val title: String, val image: String, val description: String)

private val levelContents = listOf(
    UpdateLevelContent(
        LevelKey.ABSOLUTE_BEGINNER,
        "Absolute Beginner",
        "absolute_beginner.jpg",
        "For those completely new to yoga, covering fundamental poses and breathing techniques."
    ),
    UpdateLevelContent(
        LevelKey.ADVANCED_BEGINNER,
        "Advanced Beginner",
        "advanced_beginner.jpg",
        "For those who have a basic understanding but need more guidance in developing their practice."
    ),
    UpdateLevelContent(
        LevelKey.INTERMEDIATE,
        "Intermediate",
        "intermediate.jpg",
        "For those who are comfortable with the basics and ready to explore more challenging poses and sequences."
    ),
    UpdateLevelContent(
        LevelKey.ADVANCED_INTERMEDIATE,
        "Advanced Intermediate",
        "advanced_intermediate.jpg",
        "For those who have a solid practice and are ready to refine their technique and explore advanced poses."
    ),
    UpdateLevelContent(
        LevelKey.ADVANCED,
        "Advanced",
        "advanced.jpg",
        "For experienced practitioners who are looking to deepen their practice with complex poses and sequences."
    ),
)

internal val UpdateLevelPage = FC<UpdateLevelPageProps> { props ->
    var selectedLevel by useState(props.viewModel.selectedLevel.value)

    useEffectOnce {
        scope.launch { props.viewModel.selectedLevel.collect { selectedLevel = it } }
    }

    div {
        className = ClassName("wizard-page wizard-page-has-bottom-bar")

        PageTitleSection(
            "Select your yoga experience level",
            "Your level helps us tailor the difficulty of poses and sequences to match your current abilities."
        )

        div {
            className = ClassName("wizard-list")
            levelContents.forEach { content ->
                AddTrainingRow(content.image, content.title, content.description, selectedLevel == content.key) {
                    props.viewModel.selectLevel(content.key)
                }
            }
        }
    }

    div {
        className = ClassName("wizard-bottom-bar")
        button {
            className = ClassName("outlined-button")
            disabled = selectedLevel == null
            onClick = { props.onDone() }
            +"Done"
        }
    }
}
